import { TPatientFollowup } from './followup'
import { TPatientMedEvent } from './med-event'
import { TPatientLocale } from './locales'
import { TProject } from './project'
import { TMedicalStaffMember } from './medical-staff-member'
import { TPatientMedAlert } from './med-alert'
import { TPatientWorkflow } from './patient-workflow'
import { TPatientVariable } from './variable'
import { TPatientForm } from './form'

export type TPatientStatus = 'ACTIVE' | 'PENDING_SELF_CREATION' | 'ARCHIVED'
export enum EPatientGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNKNOWN = 'UNKNOWN',
  NA = 'NA',
}

export type TPatient = {
  id: number
  isArchived?: boolean
  firstname: string
  lastname: string
  phone: string
  phoneCarrier?: string
  phoneRegion?: string
  isPhoneValid: boolean
  CommunicationChannel?: TCommunicationChannel
  communicationChannelStatus?: TPatientCommunicationChannelStatus | null
  mail?: string
  birthdate: string
  gender: EPatientGender
  zipcode?: string
  PatientMedEvents: TPatientMedEvent[]
  MedicalStaffMember: TMedicalStaffMember // referringDoctor ?
  MedicalStaffMemberId?: number
  ProjectId: number
  Project?: TProject
  PatientFollowups?: TPatientFollowup[]
  PatientConsent?: TPatientConsent
  hasCaregiver?: boolean
  isTestAccount: boolean
  status?: TPatientStatus
  PatientMedAlerts: TPatientMedAlert[]
  locale?: TPatientLocale
  PatientWorkflows: TPatientWorkflow[]
  PatientForms: TPatientForm[]
  hasMedicalTeamComments?: boolean
  medicalTeamCommentCount?: number
  nextPatientMedEvent?: TPatientMedEvent
  lastPatientMedEvent?: TPatientMedEvent
  remoteId?: string
  lifenPatientRef?: string | null
  phoneNationalFormat: string
  PatientVariables: TPatientVariable[]
}

export type TPatientCommunicationChannelStatus = 'ASSIGNED' | 'NO_CHANNEL_YET' | 'NO_CHANNEL_AVAILABLE'

export type TCommunicationChannel = {
  phone: string
  type: 'SMS' | 'RCS' | 'TIME2CHAT'
}

export type TPatientConsent = {
  consentStatus: boolean | null
  consentSendDate?: string
  consentDate?: string
}
